// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.listbox {
    padding:0;
    overflow:auto;
}
.listbox-item-content{
    padding-left:5px;
}

.listbox-item {
    cursor: pointer;
    width: 100%;
    height: 50px;
    text-align: left;
    border-radius: 0;
    color: var(--foreground-text-color);
}
    .listbox-item:hover {
        background-color: var(--primary-color);
        color: var(--foreground-text-hover-color);
    }
.listbox-item-selected {
    background-color: var(--primary-color);
    color: var(--foreground-text-hover-color);
}
.listbox-item-selected:hover {
    background-color: var(--primary-color);
}
.themeMenu{
    min-height:0;
}`, "",{"version":3,"sources":["webpack://./src/app/components/controls/themeswitch/themeswitch.control.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,aAAa;AACjB;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,mCAAmC;AACvC;IACI;QACI,sCAAsC;QACtC,yCAAyC;IAC7C;AACJ;IACI,sCAAsC;IACtC,yCAAyC;AAC7C;AACA;IACI,sCAAsC;AAC1C;AACA;IACI,YAAY;AAChB","sourcesContent":[".listbox {\n    padding:0;\n    overflow:auto;\n}\n.listbox-item-content{\n    padding-left:5px;\n}\n\n.listbox-item {\n    cursor: pointer;\n    width: 100%;\n    height: 50px;\n    text-align: left;\n    border-radius: 0;\n    color: var(--foreground-text-color);\n}\n    .listbox-item:hover {\n        background-color: var(--primary-color);\n        color: var(--foreground-text-hover-color);\n    }\n.listbox-item-selected {\n    background-color: var(--primary-color);\n    color: var(--foreground-text-hover-color);\n}\n.listbox-item-selected:hover {\n    background-color: var(--primary-color);\n}\n.themeMenu{\n    min-height:0;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
